import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { branding } from '@/config/branding';
import { installUpdate, isUpdateAvailable, subscribeToUpdate } from '@/lib/app-update';
import { Button } from '@/components/ui/primitives';

/** Avviso persistente di nuova versione: si aggiorna solo quando lo decide chi usa l'app. */
export function UpdateBanner() {
  const [visible, setVisible] = useState(isUpdateAvailable);
  const [installing, setInstalling] = useState(false);

  useEffect(() => subscribeToUpdate(setVisible), []);

  if (!visible) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md flex-wrap items-center gap-3 rounded-lg border bg-background p-3 shadow-lg"
    >
      <p className="min-w-0 flex-1 text-sm">
        È disponibile una nuova versione di {branding.productName}. Aggiorna quando non stai registrando un ordine.
      </p>
      <Button
        size="sm"
        loading={installing}
        onClick={() => {
          setInstalling(true);
          void installUpdate();
        }}
      >
        <RefreshCw aria-hidden="true" />
        Aggiorna
      </Button>
    </div>
  );
}
